import { Api } from "@/models/class/api.class";
import {
  CashFlowCategoryRequestDto,
  CashFlowCategoryResponseDto,
} from "@/models/interface/cash-flow-report-mapping";
import { ErrorResponseModel } from "@/models/interface/http.interface";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

class CashFlowMappingService extends HttpClient {
  findAll(): Promise<CashFlowCategoryResponseDto[]> {
    return this.get<CashFlowCategoryResponseDto[]>(Api.CashFlowMappingCategory)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  save(
    payload: CashFlowCategoryRequestDto[]
  ): Promise<CashFlowCategoryResponseDto[]> {
    return this.post<
      CashFlowCategoryResponseDto[],
      CashFlowCategoryRequestDto[]
    >(Api.CashFlowMappingCategory, payload)
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const cashFlowMappingService = new CashFlowMappingService();
